module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_delete-75a5549ba4cc1ea4577d17fbc7ca3bfa.svg";